import { useNavigate } from "react-router-dom";
import Button from "../../atoms/button";
import { vw } from "../../../lib/utils/responsiveUtils.ts";
import type { PaymentInfoResponse } from "../../../@apis/dto/response/payment.response.ts";
import { formatKoDayDate } from "../../../lib/utils/dateUtils.ts";

interface ScreenProps {
  item?: PaymentInfoResponse
}

export default function CompleteScreen({ item }: ScreenProps) {
  const navigate = useNavigate();

  const resveTime = item?.resveTime;
  const myMember = item?.resveTime.resveTimeMemberList?.[0];
  const Z_CLASSES = ["z-40", "z-30", "z-20", "z-10"] as const;

  const formattedCardNumber = (cardNo: string) => {
    if (typeof cardNo !== 'string' || cardNo.length !== 16) {
      return null;
    }

    const chunks = cardNo.match(/.{1,4}/g);
    if (!chunks) {
      return null;
    }
    const formatted = chunks.join("-")
    return formatted.slice(0, -1) + "*"
  }

  return (
      <div className="px-[15px] flex flex-col">
        <div className="flex flex-col justify-center items-center text-center py-[142px]">
          <img src="/icons/ic-check-circle-red.webp" style={{ width: vw(40), height: vw(40) }}/>
          <p className="font-bold pt-[14px]" style={{ fontSize: vw(24) }}>예약 완료</p>
          <span className="text-[#888] font-[500] py-[13px]" style={{ fontSize: vw(14) }}>라운드 예약을 완료하였습니다.</span>
        </div>

        {/* <div className="flex flex-col justify-center items-center text-center flex-1">
          <img src="/icons/ic-notice.webp" style={{ width: vw(40), height: vw(40) }}/>
          <p className="font-bold pt-[14px]" style={{ fontSize: vw(24) }}>예약 실패</p>
          <span className="text-[#888] font-[500] py-[13px]" style={{ fontSize: vw(14) }}>라운드 예약을 실패하였습니다.</span>
        </div> */}

        <div>
          {/* 날짜 영역 */}
          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center" style={{ height: vw(60) }}>
            <p className="font-bold text-[#222]" style={{ fontSize: vw(16) }}>
              {formatKoDayDate(resveTime?.baseDate || "")} {resveTime?.startTime || ""}
            </p>
          </div>

          <div className="mx-auto" style={{ width: vw(315), height: "1px", backgroundImage: "repeating-linear-gradient(to right,#e6e6e6 0 3px,transparent 6px 5px)", borderRadius: "2px", }} />

          {/* 내용 영역 */}
          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center" style={{ height: vw(141) }}>
            <div className="flex items-start gap-[19px]">
              <img
                className="rounded-[10px] object-cover bg-white"
                style={{ width: vw(83), height: vw(83) }}
                src="/images/img-login-logo.webp"
                alt="골프장 이미지"
              />
              <div className="flex flex-col justify-start">
                <p className="text-[#222] font-bold line-clamp-1" style={{ fontSize: vw(20) }}>
                  {resveTime?.golfParkName || ""}
                </p>
                <div className="mt-[18px] pl-[15px] border-l-[2px] border-[#e6e6e6]">
                  <p
                    className="text-[14px] text-[#333] font-[500]"
                    style={{ fontSize: vw(14) }}
                  >
                    {resveTime?.golfCourseName || ""}
                  </p>
                  {/* 참가자 아이콘 */}
                  <div className="mt-[9px] flex items-center -space-x-[10px]">
                    {[0, 1, 2, 3].map((_, i) => {
                      const m = resveTime?.resveTimeMemberList[i] || null;
                      const bg = m?.sex === undefined ? "#e6e6e6"  : m.sex === null ? "#e6e6e6"  : m.sex === 0 ? "#f95e80" : "#25a1d5";
                      const icon =
                        m?.sex === undefined
                          ? "/icons/ic-rest.webp"
                          : m.sex === null
                          ? "/icons/ic-gender.webp"
                          : m.sex === 0
                          ? "/icons/ic-female.webp"
                          : "/icons/ic-male.webp";

                      const isPayer = m && m.groupUuid === (myMember?.groupUuid ?? null);

                      return (
                        <div key={i} className={`${Z_CLASSES[i]} rounded-full flex justify-center items-center border-2 ${isPayer ? "border-[#222]" : "border-white"}`} style={{ width: vw(40), height: vw(40), backgroundColor: bg }}>
                          <img src={icon} style={{ width: vw(26), height: vw(24) }} alt="플레이어" />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-[15px]">
          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex flex-col justify-center" style={{ height: vw(106) }}>
            {/* 제목 + 총 금액 */}
            <div className="flex items-center justify-between">
              <p className="text-[#222] font-bold" style={{ fontSize: vw(16) }}>결제 정보</p>
              <p className="text-[#e5002b] font-bold" style={{ fontSize: vw(20) }}>
                {item?.amt.toLocaleString()}원
              </p>
            </div>

            {/* 결제 수단 + 금액 영역 */}
            <div className="mt-[15px] pl-[15px] border-l-[2px] border-[#e6e6e6]">
              <div className="flex justify-between">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>결제 수단</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{item?.payMethod === "CASH" ? "현장결제" : item?.payMethod === "CARD" ? `${item.cardName ?? ""}카드 ${formattedCardNumber(item.cardNo || "")}` : ""}</p>
              </div>
              <div className="flex justify-between mt-[6px]">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>결제 금액</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{item?.amt.toLocaleString('ko-KR')}원</p>
              </div>
            </div>
          </div>
        </div>

        <div className="z-50 sticky bottom-0 left-0 w-full py-[15px] bg-white flex gap-[10px]">
          <Button onClick={() => navigate("/")} className="w-full font-bold h-[50px]" variant="white" label="홈으로" />
          <Button onClick={() => navigate("/setting/reservation-history")} className="w-full font-bold h-[50px]" variant="black" label="예약 내역" />
        </div>
      </div>
  );
}